<template>
  <div class="flex flex-1 justify-end">
    <experienceable-pathway-step-button
      v-if="action && actionIsReady && !program.groups?.excluded?.length"
      :step="step"
      :primary="true"
      density="compact"
    >
      <div class="w-auto text-wrap overflow-ellipsis line-clamp-1 text-xs">
        {{ isLocked ? "Répondre à la question" : action }}
      </div>
    </experienceable-pathway-step-button>
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import ExperienceablePathwayStepButton
    from '@/program/components/experienceable-program-button/ExperienceablePathwayStepButton.vue';
import {ProgramSnapshot} from "@/program/interfaces/Program";

const props = defineProps<{
    /** The program to get the teaser action from. */
    program: ProgramSnapshot
}>();

/** The step. */
const step = computed(() => props.program.next_step || props.program.programmable?.pathway?.next_step);

/** The action. */
const action = computed(() => step.value ? step.value.resolved.action : null);

/** Whether the action is ready. */
const actionIsReady = computed(() => action.value
    && (step.value?.delay ? step.value.elapsed > step.value.delay : true));

/** Whether the action is locked. */
const isLocked = computed(() => step.value?.type === 'aftercare' &&
    step.value?.steppable?.verdict?.verdict &&
    step.value?.consumer_step?.steppable?.id
);
</script>
